import React, { useState } from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import { FaLinkedin, FaGithub, FaTwitter, FaPhone, FaEnvelope, FaCalendarAlt } from 'react-icons/fa';
import { SiGmail } from 'react-icons/si';
import './Contact.scss';

const Contact: React.FC = () => {
  const colors = useThemeColors();
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      // Simulate sending a message (replace with actual API call)
      setTimeout(() => {
        setIsSubmitted(true);
        setMessage('');
      }, 1000);
    }
  };

  return (
    <section id="contact" className="contact" style={{ 
                '--background': colors.background,
                '--surface': colors.surface,
                '--surface1': colors.surface1,
                '--primary': colors.primary,
                '--text': colors.text,
                '--accent': colors.accent,
                '--border': colors.border,
              } as React.CSSProperties}
              >
      <div className="contact__container">
        <h2 className="contact__title">Let's Work Together</h2>
        <p className="contact__subtitle">Got a project in mind? Let's discuss how I can help.</p>

        <div className="contact__grid">
          {/* Quick Actions */}
          <div className="contact__quick-actions">
            <h3>Quick Actions</h3>
            <div className="contact__action-buttons">
              <a href="mailto:anandhpradeep909@gmail.com" className="contact__action-btn">
                <FaEnvelope /> Email Me
              </a>
              <a href="tel:+919894016217" className="contact__action-btn">
                <FaPhone /> Call Me
              </a>
              <a 
                href="https://www.linkedin.com/in/anantha-pradeep-n251097/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="contact__action-btn"
              >
                <FaLinkedin /> LinkedIn
              </a>
            </div>
          </div>

          {/* Quick Message Form */}
          <div className="contact__quick-message">
            <h3>Send Me a Quick Message</h3>
            <form onSubmit={handleSubmit}>
              <textarea
                placeholder="Your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
              <button type="submit" disabled={!message.trim()}>
                {isSubmitted ? 'Sent! 🎉' : 'Send'}
              </button>
              {isSubmitted && <p className="contact__success">I'll get back to you soon!</p>}
            </form>
          </div>

          {/* Schedule a Meeting */}
          <div className="contact__meet-me">
            <h3>Schedule a Meeting</h3>
            <p>Let's discuss your project in detail.</p>
            <a 
              href="https://calendly.com/yourusername" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact__meet-btn"
            >
              <FaCalendarAlt /> Book a Call
            </a>
          </div>

          {/* Social Links */}
          <div className="contact__social-links">
            <h3>Find Me Online</h3>
            <div className="contact__social-icons">
              <a href="https://github.com/yourusername" target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </a>
              <a href="https://twitter.com/yourusername" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
              <a href="mailto:anandhpradeep909@gmail.com">
                <SiGmail />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;